import moment from 'moment';
import PropTypes from "prop-types";
import React, { useMemo } from 'react';
import { Header, Label, List, Message, Segment } from 'semantic-ui-react';
import { useMessageResources, useTextResources } from "../../language";
import * as reservationPolicyUtils from  '../shared/reservationPolicy'
import { dateTimeFormat } from "../shared/constants";
import './style.css';

const CancellationPoliciesList = ({ cancellationPolicies, reservationTotal, reservation }) => {
    const text = useTextResources()
    const message = useMessageResources();

    const freeCancellationDate = useMemo(() => {
        return reservationPolicyUtils.getFreeCancellationDate(reservation, cancellationPolicies);
    }, [reservation, cancellationPolicies])

    const isDatePassed = useMemo(() => {
        return moment().isAfter(freeCancellationDate)
    }, [freeCancellationDate])

    const upcomingCancellationFee = useMemo(() => {
        return reservationPolicyUtils.getUpcomingCancellationFee(cancellationPolicies, reservation, reservationTotal);
    }, [cancellationPolicies, reservationTotal, reservation])

    return (
        <Segment style={{ width: '100%' }}>
            <Label ribbon color='red' style={{ minWidth: 120, textAlign: 'center'}}>
                {text("Cancellation")}
                </Label>
            <List bulleted>
                {cancellationPolicies?.map(cp => (
                    <List.Item key={cp.Id} >
                        <span >{reservationPolicyUtils.getCancellationPolicyDescription(
                            cp,
                            reservationTotal
                        )}</span>
                    </List.Item>
                ))}
            </List>
            <div className='cancellation-policy-details'>
                {upcomingCancellationFee && (
                    <Header className='policy-info-header'>
                        <Header.Subheader >
                            {text('UpcomingCancellationFee')}:
                        </Header.Subheader>
                        <Header.Content>
                            <Segment color='black'>
                                {upcomingCancellationFee}
                            </Segment>
                        </Header.Content>
                    </Header>
                )}
                {freeCancellationDate && (
                    <Header className='policy-info-header'>
                        <Header.Subheader>
                            {text('FreeCancellationUntil')}:
                        </Header.Subheader>
                        <Header.Content>
                            <Segment color={isDatePassed ? 'red' : 'black'}>
                                {freeCancellationDate.format(dateTimeFormat)}
                            </Segment>
                        </Header.Content>
                    </Header>
                )}
            </div>
            {isDatePassed && (
                <Message warning size="small" visible>
                    {message('CancellationDatePassed')}
                </Message>
            )}
        </Segment>
    );
}
CancellationPoliciesList.propTypes = {
    reservation: PropTypes.object,
    reservationTotal: PropTypes.object,
    cancellationPolicies: PropTypes.array
}

export default CancellationPoliciesList
